import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { DesignFtoApi } from './apis/design-fto-api';
import { DesignFtoApiServiceImpl } from './apis/impls/design-fto-api-service';
import { DesignFtoPermissionService } from './services/design-fto-permission-service';
import { DesignFtoPermissionServiceImpl } from './services/impls/design-fto-permission-service-impl';

export function designFtoModule(bind: interfaces.Bind) {
    // 绑定 API 接口到实现 - 使用动态值绑定避免异步依赖问题
    bind(DesignFtoApiServiceImpl).toSelf().inSingletonScope();

    bind(DesignFtoApi).toDynamicValue(context => context.container.get(DesignFtoApiServiceImpl));

    bind(DesignFtoPermissionService).to(DesignFtoPermissionServiceImpl).inSingletonScope();
}

export * from './apis';
export * from './types';
export * from './constants';
